export interface IAssociatePayout {
  agentType: string;
  payoutDate: string;
  chequeNumber: string;
  payoutValue: number;
  comPersonScheme: number;
  agentName: string;
  agentNric: string;
}
